import type { MouseEvent, SyntheticEvent } from 'react'
import { legacyHookAttrs, type LegacyContractName } from '@/msgdeskRuntime/legacyBridge/SelectorContracts'
import { dispatchSubsDisclosure } from '@/msgdeskRuntime/subsDisclosure'

// Legacy fold button — self-contained (markup + wiring + Tailwind).
// ONE component for every fold: "Fold answers" / "Fold msges" (kind 'subs') and
// the main message "Fold msg" (kind 'msg').
// SKELETON: the contract hook (subs.menuToggle.* or main.foldButton) + md-fold-subs
// are the legacy fold targets; keep them on both variants.

function stopEvent(event: SyntheticEvent) {
  event.preventDefault()
  event.stopPropagation()
}

export function FoldSubsButton({
  section = 0,
  label,
  count,
  kind = 'subs',
}: {
  section?: 0 | 1
  label: string
  count?: number
  kind?: 'subs' | 'msg'
}) {
  const isMsg = kind === 'msg'
  const contract: LegacyContractName = isMsg
    ? 'main.foldButton'
    : (section === 0 ? 'subs.menuToggle.answers' : 'subs.menuToggle.submsges')

  // BEHAVIOUR: fold/unfold the message body or a subs section.
  function handleFold(event: MouseEvent<HTMLElement>) {
    stopEvent(event)
    if (isMsg) dispatchSubsDisclosure({ action: 'toggle-main' })
    else dispatchSubsDisclosure({ action: 'toggle-section', section, target: event.currentTarget })
  }

  return (
    <a
      href="#"
      {...legacyHookAttrs(contract, 'md-hook-no-select md-fold-subs float-left mr-[5px] mb-0.5 flex select-none items-center bg-green-700 p-0.5 text-[10px] text-white')}
      onClick={handleFold}
    >
      <span className="md-fold-subs__label">{label}</span>
      {!isMsg && (
        <span className="md-fold-subs__count">{typeof count === 'number' ? `(${count})` : ''}</span>
      )}
    </a>
  )
}
